import { callApi } from 'utils/api/callApi'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import { ILoad, ILoadsParams } from 'apps/fleet-planner/types/loads'

export interface IGetLoadsResponse {
  shipments: ILoad[]
  // total number of loads
  totalCount: number
}

export const getLoads = (params: ILoadsParams): Promise<IGetLoadsResponse> =>
  callApi({
    endpoint: FP_ENDPOINTS.loads,
    method: 'GET',
    params,
  })
